import React from 'react';
import { find } from 'lodash';
import { useGetUsers, useGameHasStarted } from '../hooks';
import { useParams, useHistory } from 'react-router-dom';
import { UserId } from '../containers/UserId';
import { User } from '../types';
import { PageContainer, Container, H2 } from './Layout';
import { LinkButton } from './Button';

// Fetch users before starting
export const GameLoader: React.FC<{
    children: (params: { users: User[] }) => React.ReactElement,
}> = ({ children }) => {
    const { id: roomId } = useParams();
    const history = useHistory();
    const { users, success: usersSuccess } = useGetUsers(roomId);
    const { gameHasStarted, success: gameHasStartedSuccess } = useGameHasStarted(roomId);
    const { userId } = UserId.useContainer();

    React.useEffect(() => {
        if (gameHasStartedSuccess && !gameHasStarted) {
            history.replace(`/lobby/${roomId}`);
        }
    }, [roomId, history, gameHasStarted, gameHasStartedSuccess]);

    const isLoading = !usersSuccess || !gameHasStartedSuccess;

    if (!isLoading && find(users, { userId })) {
        return children({ users });
    } else {
        return (
            <PageContainer>
                <Container>
                    <H2>
                        {isLoading
                            ? 'Loading users...'
                            : 'This game has already started, please join a different game.'}
                    </H2>
                    {!isLoading && <LinkButton to="/">Back</LinkButton>}
                </Container>
            </PageContainer>
        );
    }
};

